import React from "react";
import { Outlet, Route } from "react-router-dom";
import ForgotPass from "../pages/ForgotPass/ForgotPass";
import InactiveAccount from "../pages/InactiveAccount/InactiveAccount";
import Login from "../pages/Login/Login";
import ResetPass from "../pages/ResetPass/ResetPass";
import Signup from "../pages/Signup/Signup";
import ROUTES from ".";

function PublicLayout() {
  return <Outlet />;
}

function Public() {
  return (
    <Route path={ROUTES.PATHS.ADMIN.HOME} element={<PublicLayout />}>
      <Route path={ROUTES.PATHS.LOGIN} element={<Login />} />
      <Route path={ROUTES.PATHS.SIGNUP} element={<Signup />} />
      <Route path={ROUTES.PATHS.FORGOT_PASSWORD} element={<ForgotPass />} />

      {/* This should be protected route */}
      <Route path={ROUTES.PATHS.RESET_PASSWORD} element={<ResetPass />} />
      <Route
        path={ROUTES.PATHS.INACTIVE_ACCOUNT}
        element={<InactiveAccount />}
      />
    </Route>
  );
}

export default Public;
